import { useNavigate } from "react-router-dom";
import { Monitor, Home as HomeIcon, Lock, Settings as SettingsIcon, LayoutGrid, BookOpen, ToggleRight, Printer, ChevronRight, Shield } from "lucide-react";
import { colors, type, spacing, radius } from "@/theme";
import { useRequireAuth } from "@/lib/useRequireAuth";

const CARDS = [
  { key: "settings", label: "Impostazioni", desc: "Orari, coperto, note, flag", Icon: SettingsIcon, route: "/admin/settings" },
  { key: "tables", label: "Tavoli", desc: "Crea e gestisci i tavoli", Icon: LayoutGrid, route: "/admin/tables" },
  { key: "menu", label: "Menu", desc: "Categorie, piatti, prezzi, foto", Icon: BookOpen, route: "/admin/menu" },
  { key: "availability", label: "Disponibilità", desc: "Segna esaurito in un tap", Icon: ToggleRight, route: "/admin/availability" },
  { key: "qr", label: "QR da stampare", desc: "PDF con il QR del locale", Icon: Printer, route: "/admin/qr" },
];

export default function AdminHub() {
  const navigate = useNavigate();
  const { user } = useRequireAuth();
  if (!user) return null;

  return (
    <div style={{ minHeight: "100vh", background: colors.bg }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: `${spacing.md}px ${spacing.lg}px 0` }}>
          {user?.piano === "pro" ? (
            <button data-testid="admin-kds-button" onClick={() => navigate("/staff/kds", { replace: true })} style={plain}><Monitor size={22} color={colors.ink} /></button>
          ) : <div style={{ width: 22 }} />}
          <div style={{ ...type.serif, fontSize: 22, color: colors.ink }}>Backoffice</div>
          <button data-testid="admin-home-button" onClick={() => navigate("/", { replace: true })} style={plain}><HomeIcon size={22} color={colors.ink} /></button>
        </div>
        <div style={{ ...type.sans, fontSize: 14, color: colors.inkSoft, padding: `2px ${spacing.lg}px` }}>{user?.tenant_nome}</div>

        <div style={{ padding: spacing.lg, display: "flex", flexDirection: "column", gap: spacing.md }}>
          {user?.piano !== "pro" ? (
            <button data-testid="admin-card-upsell" onClick={() => navigate("/admin/upsell")} style={{ ...card, borderColor: colors.accent, borderStyle: "dashed" }}>
              <div style={iconWrap}><Lock size={20} color={colors.accent} /></div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <div style={{ ...type.serif, fontSize: 18, color: colors.ink }}>Ordinazione al tavolo</div>
                <div style={{ ...type.sans, fontSize: 13, color: colors.inkSoft, marginTop: 2 }}>Sblocca gli ordini dal QR e la cucina in tempo reale</div>
              </div>
              <div style={{ background: colors.accentSoft, borderRadius: radius.pill, padding: `4px ${spacing.sm}px` }}><span style={{ ...type.sansBold, fontSize: 11, color: colors.accent, letterSpacing: 0.5 }}>PRO</span></div>
            </button>
          ) : null}

          {CARDS.map((c) => (
            <button key={c.key} data-testid={`admin-card-${c.key}`} onClick={() => navigate(c.route)} style={card}>
              <div style={iconWrap}><c.Icon size={22} color={colors.accent} /></div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <div style={{ ...type.serif, fontSize: 18, color: colors.ink }}>{c.label}</div>
                <div style={{ ...type.sans, fontSize: 13, color: colors.inkSoft, marginTop: 2 }}>{c.desc}</div>
              </div>
              <ChevronRight size={22} color={colors.inkSoft} />
            </button>
          ))}

          {user?.role === "superadmin" ? (
            <button data-testid="admin-card-superadmin" onClick={() => navigate("/superadmin")} style={card}>
              <div style={iconWrap}><Shield size={22} color={colors.accent} /></div>
              <div style={{ flex: 1, textAlign: "left" }}>
                <div style={{ ...type.serif, fontSize: 18, color: colors.ink }}>Super admin</div>
                <div style={{ ...type.sans, fontSize: 13, color: colors.inkSoft, marginTop: 2 }}>Gestisci i ristoranti</div>
              </div>
              <ChevronRight size={22} color={colors.inkSoft} />
            </button>
          ) : null}

          <div style={{ ...type.sans, fontSize: 12, color: colors.inkFaint, textAlign: "center", marginTop: spacing.md }}>Tavoline — un prodotto Wattline</div>
        </div>
      </div>
    </div>
  );
}

const plain = { background: "none", border: "none", display: "flex", padding: 0 };
const card = { display: "flex", alignItems: "center", gap: spacing.md, background: colors.surface, borderRadius: radius.lg, padding: spacing.md, border: `1px solid ${colors.line}`, width: "100%" };
const iconWrap = { width: 48, height: 48, borderRadius: radius.md, background: colors.accentSoft, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 };
